import { appLocalStorage } from '../utils/storage';
import config from '../utils/config';
export const LEGAL_VERSION = '2026-10-16';
let presenter = null;
export function registerLegalPresenter(handler) {
  presenter = handler;
  return () => { if (presenter === handler) presenter = null; };
}
export function requestLegalConsent(legal, token, signal) {
  if (!presenter || !token || token !== appLocalStorage.getItem(config.token) || signal?.aborted ||
    legal?.version !== LEGAL_VERSION || !legal.required ||
    ['terms', 'opinions', 'ai'].some(key => typeof legal.required[key] !== 'boolean')) return Promise.resolve(false);
  return presenter({ legal, token, signal });
}
export function manageLegalConsent() {
  const token = appLocalStorage.getItem(config.token);
  return presenter && token ? presenter({ token, manage: true }) : Promise.resolve(false);
}
